import useApiHook from '../../../../hooks/api/useApiHook';
import { useCallback } from 'react';

export const useGetCustomer = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getCustomer = useCallback(async (id) => {
    const url = `/customers/${id}`;
    await get(url);
  }, [get]);

  return { getCustomer, data, error, loading };
};

export const usePutCustomer = () => {
  const { put, data, error, loading } = useApiHook(true);

  const putCustomer = useCallback(async (id, body) => {
    const url = `/customers/${id}`;
    await put(url, body);
  }, [put]);

  return { putCustomer, data, error, loading };
};

export const usePostCustomer = () => {
  const { post, data, error, loading } = useApiHook(true);

  const postCustomer = useCallback(async (body) => {
    const url = `/customers`;
    await post(url, body);
  }, [post]);

  return { postCustomer, data, error, loading };
};

export const useSetCustomerState = () => {
  const { post, data, error, loading } = useApiHook(true);

  const postCustomerState = useCallback(async (id, action) => {
    const url = `/customers/${id}/${action}`;
    await post(url);
  }, [post]);

  return { postCustomerState, data, error, loading };
};

export const useGetUsersEnum = () => {
  const { get, data, error, loading } = useApiHook(true);

  const getUsersEnum= useCallback(async () => {
    const url = `/enums/users`;
    await get(url);
  }, [get]);

  return { getUsersEnum, data, error, loading };
};
